import { useEffect, useState } from 'react';
import { listDepartments, type Department } from '../api/client';
import { Icon } from '../components/Icon';

export function Departments() {
  const [rows, setRows] = useState<Department[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listDepartments().then((r) => setRows(r.items)).catch((err: Error) => setError(err.message));
  }, []);

  return (
    <>
      <div className="page-head">
        <div>
          <span className="eyebrow">
            <Icon name="departments" size="xs" />
            <span>Organization Structure</span>
          </span>
          <h1>Departments & Cost Centers</h1>
        </div>
      </div>
      {error && <div className="banner error">{error}</div>}
      <div className="panel">
        {rows.length === 0 && !error ? (
          <div className="empty">
            <strong>No departments configured yet</strong>
            <p>Departments organize workforce structures and cost center allocations.</p>
          </div>
        ) : (
          <div className="table-responsive">
            <table>
              <thead>
                <tr><th style={{ width: 120 }}>Code</th><th>Name</th><th>Cost Center</th></tr>
              </thead>
              <tbody>
                {rows.map((d) => (
                  <tr key={d.id}>
                    <td className="mono"><strong>{d.code}</strong></td>
                    <td>{d.name}</td>
                    <td className="mono muted">{d.cost_center ?? '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
